import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=898862c0&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"
import style0 from "./qualification.vue?vue&type=style&index=0&id=898862c0&prod&lang=scss"
import style1 from "./qualification.vue?vue&type=style&index=1&id=898862c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898862c0",
  null
  
)

export default component.exports